// AboutAlumni Component
import React, { useEffect, useState } from "react";
import Page from "../../Components/Page";
import ReactQuill from "react-quill";
import toast from "react-hot-toast";
import { getAlumniData, updateAlumniData } from "../../controllers/alumni.controller";

const AboutAlumni = () => {
  const [formData, setFormData] = useState({
    vision: "",
    mission: "",
    goals: "",
  });

  const [editMode, setEditMode] = useState(false); // Tracks edit mode

  useEffect(() => {
    const fetchApiData = async () => {
      try {
        const res = await getAlumniData();
        if (res.status === 200) {
          const apiData = res?.data?.data?.[0];
          if (apiData) {
            setFormData({
              vision: apiData.vision || "",
              mission: apiData.mission || "",
              goals: apiData.goals || "",
            });
          }
        } else {
          toast.error("Failed to fetch data");
        }
      } catch (error) {
        toast.error("Failed to fetch data");
        console.error(error);
      }
    };

    fetchApiData();
  }, []);





  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      goals: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { vision, mission, goals } = formData;

    if (!vision.trim() || !mission.trim() || !goals.trim()) {
      toast.error("All fields are required");
      return;
    }

    try {
      toast.loading("Saving changes...");
      const updateData = { id: 1, ...formData }; // Assuming ID is 1
      const response = await updateAlumniData(updateData);
      toast.dismiss();

      if (response.status === 200) {
        toast.success("Data successfully updated!");
        setEditMode(false); // Exit edit mode
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Failed to update data");
      console.error(error);
    }
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline"],
      [{ align: [] }],
      ["clean"],
    ],
  };

  const formats = ["font", "header", "bold", "italic", "underline", "align"];

  return (
    <Page className="px-8 py-6">
      <div className="p-6">
        <div className="flex items-center gap-10 text-xl">
          <div className="text-[#4B465C]">
            Alumni / <span className="mt-6 text-black bg-white">About Alumni</span>
          </div>
        </div>
        <form
          onSubmit={handleSubmit}
          className="p-5 mt-8 bg-gray-100 border border-gray-300 rounded-lg"
        >
          <h2>{editMode ? "Edit Alumni Vision, Mission & Goals" : "Alumni Vision, Mission & Goals"}</h2>

          <div className="mb-4">
            <label htmlFor="vision" className="block mb-2 font-medium text-gray-700">
              Message
            </label>
            <textarea
              id="vision"
              name="vision"
              value={formData.vision}
              onChange={handleChange}
              // disabled={!editMode}
              className="w-full p-2 rounded border border-gray-300 min-h-[80px] resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* <div className="mb-4">
            <label htmlFor="mission" className="block mb-2 font-medium text-gray-700">
              Mission Message
            </label>
            <textarea
              id="mission"
              name="mission"
              value={formData.mission}
              onChange={handleChange}
              // disabled={!editMode}
              className="w-full p-2 rounded border border-gray-300 min-h-[80px] resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="col-span-2 h-[200px]">
            <label htmlFor="goal" className="block mb-2 font-medium text-gray-700">
              Goals
            </label>
            <div className="h-full overflow-hidden border border-gray-300 rounded-md focus-within:border-gray-400">
              <ReactQuill
                id="goals"
                value={formData.goals}
                onChange={handleQuillChange}
                theme="snow"
                modules={modules}
                formats={formats}
                // className={`h-[300px] ${!editMode ? "pointer-events-none" : ""}`}
                placeholder="Enter your goals here..."
              />
            </div>
          </div> */}

          <div className="flex justify-end gap-2 mt-12">
          
              <>
                <button
                  type="button"
                  className="px-5 py-2 bg-gray-200 border border-gray-300 rounded cursor-pointer hover:bg-gray-300"
                  onClick={() => setEditMode(false)}
                >
                Clear
                </button>
                <button
                  type="submit"
                  className="bg-[#92288C] text-white rounded px-5 py-2 cursor-pointer hover:bg-[#92288C]"
                >
                  Update
                </button>
              </>
            
          </div>
        </form>
      </div>
    </Page>
  );
};

export default AboutAlumni;



